<div class="grid-mobile-1 grid-tablet-1 grid-desktop-4 full-height">
  @if (this.config.view.portal.questions) {
    <div class="col-span-desktop-2">
      <app-card header="Veelgestelde vragen">
        <app-badge size="small" ngProjectAs="[badge]" icon="comments-question"/>
        <span>
        Op onze website staan een groot aantal antwoorden op veelgestelde vragen.
        Grote kans dat het antwoord op jouw vraag daar ook te vinden is.
      </span>
        <app-button
          ngProjectAs="[button]"
          [link]="this.config.support.contact.url"
          type="outline">
          Bekijken
        </app-button>
      </app-card>
    </div>
  }
  @if (this.config.view.portal.manual) {
    <div class="col-span-desktop-2">
      <app-card header="Handleiding">
        <app-badge ngProjectAs="[badge]" size="small" icon="book"/>
        <span>{{this.config.view.portal.text.manual}}</span>
        <app-button
          ngProjectAs="[button]"
          link="{{this.config.support.manual_url}}"
          type="outline">
          Bekijken
        </app-button>
      </app-card>
    </div>
  }
  @if (this.config.view.portal.whatsapp) {
    <div class="col-span-desktop-2">
      <app-card header="WhatsApp">
        <app-badge ngProjectAs="[badge]" size="small" type="brands" icon="whatsapp"></app-badge>
        <span>Chat op WhatsApp met {{ this.config.support.contact.whatsapp }}.
          Let op: dit opent een externe website.</span>
        <app-button
          ngProjectAs="[button]"
          link="{{ this.config.support.contact.whatsapp_url}}"
          type="outline">
          Contact opnemen
        </app-button>
      </app-card>
    </div>
  }
  @if (this.config.view.portal.facebook) {
      <div class="col-span-desktop-2">
        <app-card header="Facebook">
          <app-badge ngProjectAs="[badge]" size="small" type="brands" icon="facebook-messenger"></app-badge>
          <span>Chat met ons op Facebook Messenger. Let op: dit opent een externe website.</span>
          <app-button ngProjectAs="[button]" link="{{this.config.support.contact.facebook}}" type="outline">
            Contact opnemen
          </app-button>
        </app-card>
      </div>
  }
  @if (this.config.view.portal.chat) {
      <div class="col-span-desktop-2">
        <app-card header="Meldingen">
          <app-badge ngProjectAs="[badge]" size="small" icon="ticket"></app-badge>
          <span>Stuur je vraag via een melding naar de klantenservice.</span>
          <app-button ngProjectAs="[button]" routerLink="/dashboard/customersupport/tickets/new">
            Nieuwe melding
          </app-button>
          <app-button ngProjectAs="[button]" routerLink="{{this.config.support.contact.chat}}" type="outline">
            Alles bekijken
          </app-button>
        </app-card>
      </div>
  }
  @if (this.config.view.portal.phone) {
    <div class="col-span-desktop-2">
      <app-card header="Telefoongesprek">
        <app-badge ngProjectAs="[badge]" size="small" icon="phone"></app-badge>
        <span>Liever telefonisch contact? Bel naar {{ this.config.support.contact.phone }}.</span>
        <app-button
          ngProjectAs="[button]"
          link="tel:{{this.config.support.contact.phone | phone}}"
          type="outline">
          Contact opnemen
        </app-button>
      </app-card>
    </div>
  }
</div>
